import React from 'react';
import { browserHistory } from 'react-router';
import ButtonChoice from '../Fields/ButtonChoice';
import SubmitButton from '../Fields/SubmitButton';
import TextInput from '../Fields/TextInput';
import NumberInput from '../Fields/NumberInput';
import SortcodeInput from '../Fields/SortcodeInput';
import GlobalHeader from '../Fragments/GlobalHeader';
import moment from 'moment';

let Quote = require('../Managers/Quote');
let Policy = require('../Managers/Policy');
let Payment = require('../Managers/Payment');
let StepManager = require('../Managers/Steps');
let ReactGA = require('react-ga');
let HttpService = require('../Managers/HttpService');

const Config = HttpService.getConfigForHost();
const PaymentScreen = React.createClass ({

    getInitialState() {
        return {
            activeStep: 0,
            totalNumberOfSteps: StepManager.totalNumberOfSteps(),
            quote: Quote.getQuote(),
            processingPayment: false,
            paymentMethod: (Payment.get('payment_method')) ? Payment.get('payment_method') : false,
            paymentFrequency: (Payment.get('payment_frequency')) ? Payment.get('payment_frequency') : false,
            isValid: false,
            hasError: false,
            errors: null,
            displayErrors: null,
            isAccountValid: false,
            accountErrors: null,
            secpaysecure: null
            
        };
    },

    componentWillMount() {
        window.localStorage.removeItem('jpk');
        ReactGA.initialize('UA-1926380-5');
    },

    componentDidMount() {
        window.localStorage.removeItem('jpk');
        // Push event to GA
        ReactGA.event({
            category: 'Landlord Insurance',
            action: 'Payment Step',
            label: 'Quote Form'
        });

        if (!Quote.hasQuote()) {
            browserHistory.push('/start');
        }
        window.scrollTo(0, 0);
    },

    componentDidUpdate: function() {
        $(document).ready(function() {
            if (document.forms.length > 0) {
                document.forms[0].submit();
            }
        });
    },

    moveBack() {
        // Quote summary is always preceding payment page
        browserHistory.push('/quote');
    },

    getUnansweredQuestions() {
        let unansweredQuestions = [];
        let fieldData = {
            fieldscc : [
            ],
            fieldsdd : [
                {
                    'field':'payment_frequency',
                    'title':'How often would you like to pay?'
                },
                {
                    'field':'account_name_confirm',
                    'title':'Can you confirm that the bank account is in your name?'
                },
                {
                    'field':'account_single_auth',
                    'title':'Can you confirm that only one person is required to authorise debits from this account?'
                },
                {
                    'field':'customer',
                    'title':'Account holder name'
                },
                {
                    'field':'account_no',
                    'title':'Account number'
                },
                {
                    'field':'sort_code',
                    'title':'Sort Code'
                }
            ]
        };
        let paymentMethod = Quote.getCurrentAnswer('payment_method');
        if (!paymentMethod) {
            unansweredQuestions.push('Please choose your payment method');
        } else {
            fieldData['fields' + paymentMethod].map(function(i) {
                if (('account_name_confirm' == i.field || 'account_single_auth' == i.field) && Quote.getCurrentAnswer(i.field) == 'no') {
                    unansweredQuestions.push(i.title);
                }
                if (!Quote.getCurrentAnswer(i.field)) {
                    unansweredQuestions.push(i.title);
                }
            });
        }
        // Delete duplicate results in return due to multiple sort code fields
        return Array.from(new Set(unansweredQuestions));
    },

    validateBankAccount() {
        let accountDetails = {};
        accountDetails["account_number"] = Quote.getCurrentAnswer('account_no');
        accountDetails["sort_code"] = Quote.getCurrentAnswer('sort_code');

        let isValid = false;

        $.ajax({
            type: Config.api.bankAccountLookup.method,
            data: accountDetails,
            async: false,
            url: Config.api.bankAccountLookup.url,
            success: function(response) {
                if (typeof response === 'object' && response.is_account_valid === true) {
                    isValid = true;
                    let errors = this.getUnansweredQuestions();
                    if (errors.length > 0) {
                        isValid = false;
                        this.setState({
                            displayErrors: errors
                        });
                        window.scrollTo(0, 0);
                    }
                } else {
                    this.setState({
                        displayErrors: ['The bank account details are not valid']
                    });
                    window.scrollTo(0, 0);
                }
            }.bind(this),
            error: function() {
                this.setState({
                    displayErrors: ['The bank account details are not valid']
                });
                window.scrollTo(0, 0);
            }.bind(this)
        });

        return isValid;
    },

    pay() {
        let errors = this.getUnansweredQuestions();
        if (errors.length > 0) {
            this.setState({
                displayErrors: errors
            });
            window.scrollTo(0, 0);
            return;
        }
        this.setState({
            processingPayment: true
        });
        let _this = this;
        let monthlyPaymentAmount = this.state.quote.premiums.monthly.raw.gross_inc_ipt_and_fee;
        let annualPaymentAmount = this.state.quote.premiums.annual.raw.gross_inc_ipt_and_fee;
        let paymentAmount = (this.state.paymentFrequency == 'Monthly') ? monthlyPaymentAmount : annualPaymentAmount;
        Payment.pay(Config.api.payment.method, Config.api.payment.url, paymentAmount).then(
            function(response){
                if (response.secpaysecure) {
                    _this.setState({
                        secpaysecure: response.secpaysecure,
                        processingPayment: false
                    });
                    return response.secpaysecure;
                } else if (response.pay360) {
                    window.location.replace(response.pay360);
                }
            },
            function(error){
                window.localStorage.setItem('policy_error', error);
                browserHistory.push('/error');
            }
        );
    },

    processDdPaymentAndIncept() {
        this.setState({
            displayErrors: null
        });

        if (this.state.paymentMethod == 'dd' && ! this.validateBankAccount()) {
            return false;
        }

        let errors = this.getUnansweredQuestions();
        if (errors.length > 0) {
            this.setState({
                displayErrors: errors
            });
            window.scrollTo(0, 0);
            return;
        }

        this.setState({
            processingPayment: true
        });
        Payment.processDdPaymentAndIncept(Config.api.inception.method, Config.api.inception.url).then(
            function(policy){
                if (typeof policy === 'object' && policy.policy_no && policy.policy_no != 'undefined') {
                    policy.title = Quote.getQuote().title;
                    policy.firstName = Quote.getQuote().first_name;
                    policy.lastName = Quote.getQuote().last_name;
                    Policy.cachePolicy(policy);
                    browserHistory.push('/success');
                }
            },
            function(error) {
                if (error.status === 0) {
                    Policy.cachePolicyError(error);
                }
                browserHistory.push('/payment-error');
            }
        );

    },

    handleChildUpdate(value) {
        if (value == 'cc' || value == 'dd') {
            this.setState({
                paymentMethod: value
            });
        }
    },

    handleAccSingleAuthUpdate(value) {
        this.setState({
            accSingleAuth: value
        });
    },

    handleAccNameConfirmUpdate(value) {
        this.setState({
            accNameConfirm: value
        });
    },

    handleFrequency(value) {
        if (value == 'Monthly' || value == 'Annually') {
            this.setState({ paymentFrequency: value });
        }
    },

    render() {
        let ddStartDate = moment(Quote.getCurrentAnswer('policy_start'), 'DD/MM/YYYY').add(1, 'months').format('DD/MM/YYYY');
        let submitMethod = (this.state.paymentMethod === 'cc') ? this.pay : this.processDdPaymentAndIncept;
        let displayerrors = [];
        if (this.state.displayErrors !== null) {
            this.state.displayErrors.map(function(questionTitle) {
                displayerrors.push(<li>{questionTitle}</li>);
            }, this);
        }
        let adminFee = this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee - this.state.quote.premiums.monthly.formatted.gross_inc_ipt;
        let initialPayment = ((this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee * 2) - adminFee).toFixed(2); 
        let totalMonthlyPayments = 10;
        return (
            <div>
            {this.state.secpaysecure ?
                <div dangerouslySetInnerHTML={{__html: this.state.secpaysecure}} />
            :
            <div>
                <GlobalHeader />
                <div className="stepless" />
                {this.state.displayErrors !== null ?
                    <div className="container pageValidationErrors">
                        <p>{this.state.isAccountValid ? "Please answer the following questions:" : "Please correct the issue below:"}</p>
                        <ul>{displayerrors}</ul>
                    </div>
                : null }
                <question-row class="no-border unpadded">
                    <h1>Payment</h1>
                </question-row>
                <ButtonChoice
                    question="How often would you like to pay?"
                    fieldName="payment_frequency"
                    loadCachedValue={true}
                    questionId={0}
                    options={[
                        {
                            option_text: 'Monthly',
                            option_value: 'Monthly'
                        },
                        {
                            option_text: 'Annually',
                            option_value: 'Annually'
                        }
                    ]}
                    onSetValue={this.handleFrequency}
                />

                <ButtonChoice
                    question="Please choose your payment method"
                    fieldName="payment_method"
                    loadCachedValue={true}
                    questionId={0}
                    options={[
                        {
                            option_text: 'Direct debit',
                            option_value: 'dd'
                        },
                        {
                            option_text: 'Debit/Credit card',
                            option_value: 'cc'
                        }
                    ]}
                    onSetValue={this.handleChildUpdate}
                />

                {this.state.paymentMethod && this.state.paymentFrequency ?
                    <div className="container">
                        {this.state.paymentMethod === 'cc' && this.state.paymentFrequency === 'Annually' ?
                            <div className="price-container standalone cc single">
                                <div className="arrow" />
                                <header>
                                    <h3>A single payment</h3>
                                </header>
                                <p>
                                    <span className="yearly-price price">£<span className="price-value">
                                        {this.state.quote.premiums.annual.formatted.gross_inc_ipt_and_fee}
                                    </span></span>
                                    <span>Including Insurance Premium Tax at the current rate.</span> 
                                </p>
                            </div>
                        : null}

                        {this.state.paymentMethod === 'cc' && this.state.paymentFrequency === 'Monthly' ?
                            <div className="price-container standalone cc single">
                                <div className="arrow" />
                                <header>
                                    <h3>Monthly payments</h3>
                                </header>
                                <p>
                                    <span className="monthly-price price">£<span className="price-value">
                                        {this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee}
                                    </span></span>
                                </p>
                                <div className="price-supplemental">
                                An initial payment of <b>£{this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee}</b> on <b>{ddStartDate}</b> followed by <b>11</b> monthly payments of <b>£{this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee}</b>, 
                                        <br/> 
                                        total amount due <b>£{(12 * this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee).toFixed(2)}</b> Including an administration fee of <b>£{(adminFee).toFixed(2)}</b> each month and Insurance Premium Tax at the current rate. 
                                       </div>
                            </div>
                        : null}

                        {this.state.paymentMethod === 'dd' && this.state.paymentFrequency === 'Annually' ?
                            <div className="price-container standalone dd single">
                                <div className="arrow" />
                                <header>
                                    <h3>A single payment</h3>
                                </header>
                                <p>
                                    <span className="yearly-price price">£<span className="price-value">
                                        {this.state.quote.premiums.annual.formatted.gross_inc_ipt_and_fee}
                                    </span></span>
                                    <span>Including Insurance Premium Tax at the current rate.</span> 
                                </p>
                            </div>
                        : null}

                        {this.state.paymentMethod === 'dd' && this.state.paymentFrequency === 'Monthly' ?
                            <div>
                                <div className="price-container standalone dd monthly">
                                    <div className="column">
                                        <div className="arrow" />
                                        <header>
                                            <h3>Your first payment</h3>
                                        </header>
                                        <p>
                                            <span className="monthly-price price">£<span className="price-value">
                                                {((this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee * 2) - adminFee).toFixed(2)}
                                            </span></span>
                                        </p>
                                    </div>

                                    <div className="column">
                                        <header>
                                            <h3>Your monthly payment</h3>
                                        </header>
                                        <p>
                                            <span className="monthly-price price">£<span className="price-value">
                                                {this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee}
                                            </span></span>
                                        </p>
                                    </div>
                                </div>
                                <div className="price-supplemental">
                                        An initial payment of <b>£{((this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee * 2) - adminFee).toFixed(2)}</b> on <b>{ddStartDate}</b> followed by <b>10</b> monthly payments of <b>£{this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee}</b>, 
                                        <br/> 
                                        total amount due <b>£{(parseFloat(initialPayment) + 
                                                            (totalMonthlyPayments* this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee)).toFixed(2)}</b> Including an administration fee of <b>£{(adminFee).toFixed(2)}</b> each month and Insurance Premium Tax at the current rate. 
                                </div>
                            </div>
                        : null}
                    </div>
                : null}

                {this.state.paymentMethod === 'dd' ?
                    <div>
                        <ButtonChoice
                            question="Can you confirm that the bank account is in your name?"
                            fieldName="account_name_confirm"
                            loadCachedValue={true}
                            questionId={0}
                            options={[
                                {
                                    option_text: 'Yes',
                                    option_value: 'yes'
                                },
                                {
                                    option_text: 'No',
                                    option_value: 'no'
                                }
                            ]}
                            onSetValue={this.handleAccNameConfirmUpdate}
                        />
                        <ButtonChoice
                            question="Can you confirm that only one person is required to authorise debits from this account?"
                            fieldName="account_single_auth"
                            loadCachedValue={true}
                            questionId={0}
                            options={[
                                {
                                    option_text: 'Yes',
                                    option_value: 'yes'
                                },
                                {
                                    option_text: 'No',
                                    option_value: 'no'
                                }
                            ]}
                            onSetValue={this.handleAccSingleAuthUpdate}
                        />
                        <TextInput
                            question="Account holder name"
                            fieldName="customer"
                            loadCachedValue={true}
                            maxLength={50}
                         />
                        <NumberInput
                            question="Account number"
                            fieldName="account_no"
                            loadCachedValue={true}
                            maxLength={50}
                        />
                        <SortcodeInput
                            question="Sort Code"
                            fieldName="sort_code"
                            inputMask="99"
                        />
                        <div className="alternate-background">
                            <question-row class="no-border">
                                <div className="question-main">
                                    <div className="question-top">
                                        <div>
                                            <h3>The Direct Debit Guarantee</h3>
                                            <ul>
                                                <li>
                                                    This Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits.
                                                </li>
                                                <li>
                                                    If there are any changes to the amount, date or frequency of your Direct Debit HomeLet will notify you 10 working days in advance of your account being debited or as otherwise agreed. If you request HomeLet to collect a payment, confirmation of the amount and date will be given to you at the time of the request.
                                                </li>
                                                <li>
                                                    If an error is made in the payment of your Direct Debit by HomeLet or your bank or building society you are entitled to a full and immediate refund of the amount paid from your bank or building society<br />
                                                    - If you receive a refund you are not entitled to, you must pay it back when HomeLet asks you to.
                                                </li>
                                                <li>
                                                    You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify us.
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </question-row>
                        </div>
                    </div>
                : null}

                <question-row class="no-border">
                    <div className="question-main">
                        <div className="question-top">
                            <p>Your policy will automatically renew at the end of the term. We&rsquo;ll write to you before your renewal date as a reminder. You can also change your renewal preference at any time online using MyHomeLet or by contacting us.</p>
                        </div>
                        <SubmitButton
                            label="Make Payment"
                            backLink={this.moveBack}
                            spinnerMessage="Processing your payment..."
                            loading={this.state.processingPayment}
                            onClick={submitMethod}
                        />
                    </div>
                </question-row>
                </div>
                }
            </div>
        );
    }
}
);

export default PaymentScreen;



/** WEBPACK FOOTER **
 ** ./src/components/Screens/PaymentScreen.js
 **/